import { useIntl } from 'react-intl';
import { isDaySelected, onKeyboardEventHandler, workingHourForTheDay } from '../TimesheetsCalendarUtil';
import { format, getWeek, isBefore, isSameDay, isToday } from 'date-fns';
import { CellText, CellTextBold, DayCellStyle, DayInfoWrapper } from '../TimesheetsCalendar_styled';
import { TodayText } from './DayCell_styled';
import { FlexColumn, FlexRow, Icon } from '@forecast-it/design-system';
import React, { useMemo } from 'react';
import { getTimeRegistrationsOfTheDay, separateWorkingTimeAndTimeOff } from '../../timesheets_time_registrations';
import Util from '../../../../shared/util/util';
import { CalendarEvents } from '../calendar-events/CalendarEvents';
import { EventCount } from '../calendar-events/CalendarEvent_styled';
export const DayCell = ({ timeRegistrations, currentPersonViewed, selectedDate, selectDateFromCalendar, lockedDate, day, isDayOutsideViewingMonth, holidaysOfTheDay, calendarEvents, isEventConverted, isLoadingCalendarEvents, dayCountMap, currentViewingDate, openModal, showContextMenu, }) => {
    const intl = useIntl();
    const timeRegistrationsForDay = getTimeRegistrationsOfTheDay(day, timeRegistrations.edges);
    const workingHours = workingHourForTheDay(currentPersonViewed, day);
    const timeWorked = separateWorkingTimeAndTimeOff(timeRegistrationsForDay);
    const totalTime = timeWorked.timeOff + timeWorked.workingTime;
    const isDayFullTimeOff = timeWorked.timeOff > 0 && workingHours - timeWorked.timeOff <= 0;
    const totalTimeInHours = Util.convertMinutesToFullHour(totalTime, intl, true);
    const daySelected = isDaySelected(selectedDate, day);
    const isHoliday = holidaysOfTheDay.length > 0;
    const isLocked = lockedDate && (isSameDay(day, lockedDate) || isBefore(day, lockedDate));
    const isDayToday = isToday(day);
    const checkMarkColor = isLocked ? 'disabledOnDisabled' : 'success';
    const isWeekSelected = getWeek(currentViewingDate) === getWeek(day);
    const showCheckMark = totalTime >= workingHours && workingHours > 0;
    const showTotalTime = timeRegistrationsForDay.length > 0;
    const showTimeSection = showCheckMark || showTotalTime;
    const showLockIcon = isLocked;
    const showTimeOffIcon = (isDayFullTimeOff || isHoliday) && !isLocked;
    let textColor = 'default';
    if (isDayOutsideViewingMonth) {
        textColor = 'onLight';
    }
    else if (isLocked) {
        textColor = 'disabledOnDisabled';
    }
    const getDayCount = day => {
        return dayCountMap.get(format(day, 'yyyy-MM-dd'));
    };
    const eventCount = useMemo(() => getDayCount(day), [dayCountMap.size]);
    const showEventCount = false;
    const date = day.getDate();
    return (React.createElement(DayCellStyle, { tabIndex: 0, hoverable: true, locked: isLocked, selected: daySelected, onClick: () => selectDateFromCalendar(day, false), onKeyDown: event => onKeyboardEventHandler(event, day, false, selectDateFromCalendar) },
        React.createElement(FlexColumn, null,
            React.createElement(DayInfoWrapper, null,
                React.createElement(FlexColumn, { rowGap: 'l' },
                    React.createElement(FlexRow, { gap: 'xs', justifyContent: 'start', alignItems: 'center' },
                        isHoliday ? (React.createElement(FlexColumn, { flex: 3 },
                            React.createElement(CellText, { color: 'disabledOnDisabled' }, holidaysOfTheDay[0].node.name))) : null,
                        React.createElement(FlexColumn, { flex: 1 },
                            React.createElement(FlexRow, { justifyContent: 'end', alignItems: 'center' },
                                showLockIcon ? React.createElement(Icon, { color: 'disabledOnDisabled', icon: "lockClosed" }) : null,
                                showTimeOffIcon ? React.createElement(Icon, { color: 'disabledOnDisabled', icon: "timeOff" }) : null,
                                date === 1 ? React.createElement(CellTextBold, { color: textColor }, format(day, 'MMM')) : null,
                                isDayToday ? (React.createElement(TodayText, null, date)) : (React.createElement(CellTextBold, { color: textColor }, date))))),
                    React.createElement(FlexRow, { gap: 'xs', justifyContent: 'start', alignItems: 'center' },
                        showEventCount && !(calendarEvents === null || calendarEvents === void 0 ? void 0 : calendarEvents.length) && eventCount ? (React.createElement(FlexColumn, { flex: '1 1' },
                            React.createElement(EventCount, null,
                                eventCount,
                                " calendar events"))) : null,
                        showTimeSection ? (React.createElement(FlexColumn, { flex: '1 0' },
                            React.createElement(FlexRow, { justifyContent: 'end', alignItems: 'center' },
                                showCheckMark ? React.createElement(Icon, { color: checkMarkColor, icon: "checkCircle" }) : null,
                                React.createElement(CellText, { color: textColor }, showTotalTime ? totalTimeInHours : null)))) : null))),
            React.createElement(CalendarEvents, { calendarEvents: calendarEvents, isEventConverted: isEventConverted, isLocked: isLocked, renderPlaceholders: isLoadingCalendarEvents && isWeekSelected, openModal: openModal, showContextMenu: showContextMenu }))));
};
export default DayCell;
